import { jsPDF } from 'jspdf'

const TEAL = [27, 110, 107]
const TEXT = [26, 26, 26]
const MUTED = [107, 111, 110]

const fmtDate = (iso) =>
  iso ? new Date(iso + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : '—'

// Generate and download a one-appointment summary PDF.
export function generateAppointmentPDF(recipient, appt) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' })
  const M = 56
  const W = doc.internal.pageSize.getWidth()
  let y = M

  // Header band
  doc.setFillColor(...TEAL)
  doc.rect(0, 0, W, 8, 'F')

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(22)
  doc.setTextColor(...TEAL)
  doc.text('Appointment Summary', M, (y += 24))

  doc.setFont('helvetica', 'normal')
  doc.setFontSize(10)
  doc.setTextColor(...MUTED)
  doc.text('Mapa Care', M, (y += 16))

  y += 14

  // Care recipient
  const dob = recipient.date_of_birth ? fmtDate(recipient.date_of_birth) : '—'
  y = field(doc, M, y, 'Care recipient', recipient.full_name || '—')
  y = field(doc, M, y, 'Date of birth', dob)

  y += 8
  doc.setDrawColor(228, 228, 224)
  doc.line(M, y, W - M, y)
  y += 18

  // Appointment details
  y = field(doc, M, y, 'Doctor', appt.doctor_name || '—')
  if (appt.specialty) y = field(doc, M, y, 'Specialty', appt.specialty)
  y = field(doc, M, y, 'Date', fmtDate(appt.appointment_date))
  if (appt.appointment_time) y = field(doc, M, y, 'Time', appt.appointment_time.slice(0, 5))
  if (appt.location) y = field(doc, M, y, 'Location', appt.location)
  if (appt.purpose) y = block(doc, M, W, y, 'Purpose', appt.purpose)

  y += 6
  y = block(doc, M, W, y, 'Pre-appointment notes (what to discuss)', appt.pre_appointment_notes || 'None recorded.')
  y = block(doc, M, W, y, 'After the visit (what was decided)', appt.post_appointment_notes || 'Not yet recorded.')
  y = block(doc, M, W, y, 'Action items', appt.action_items || 'None recorded.')

  // Footer
  doc.setFontSize(9)
  doc.setTextColor(...MUTED)
  doc.text(
    `Generated ${new Date().toLocaleDateString()} · Mapa Care`,
    M,
    doc.internal.pageSize.getHeight() - 32
  )

  const safeName = (recipient.full_name || 'appointment').replace(/[^a-z0-9]+/gi, '-').toLowerCase()
  doc.save(`${safeName}-${appt.appointment_date || 'appointment'}.pdf`)
}

function field(doc, x, y, label, value) {
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(10)
  doc.setTextColor(...MUTED)
  doc.text(label.toUpperCase(), x, (y += 18))
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(12)
  doc.setTextColor(...TEXT)
  doc.text(String(value), x, (y += 15))
  return y
}

function block(doc, x, w, y, label, value) {
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(10)
  doc.setTextColor(...MUTED)
  doc.text(label.toUpperCase(), x, (y += 20))
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(11)
  doc.setTextColor(...TEXT)
  const lines = doc.splitTextToSize(String(value), w - x * 2)
  doc.text(lines, x, (y += 15))
  return y + lines.length * 14
}
